import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  req = req.clone({
    setHeaders: {
      'x-api-key': environment.apiKey,
      'x-brand-key': environment.brandKey,
      'x-user-id': environment.userId
    }
  });


  return next(req);
};